/**
 * Active Dialogs utils
 */
import React from 'react';
import { IDialog, IDialogParamGroups, IDialogName } from './types';
import { Location } from 'react-router-dom';
import { PatientTabIdType } from '../../libs/patient';
import AddressEvents from '../../components/organisms/event/address';
import ViewPatientDialog from '../../components/organisms/dialog/patient';
import PushMessage from '../../components/organisms/pm/dialog';
import BulkPushMessage from '../../components/organisms/pm/bulkPmDialog';

type CloseDialogFunction = (dialog: IDialog) => void;

export const chooseComponent = (
  dialog: IDialog,
  closeDialog: CloseDialogFunction
): JSX.Element => {
  let component: JSX.Element = null;
  switch (dialog.name) {
    case 'AddressEvents':
      component = (
        <AddressEvents
          key={dialog.id}
          isOpen
          close={() => closeDialog(dialog)}
          payload={dialog.payload}
        />
      );
      break;
    case 'ViewPatient':
      component = (
        <ViewPatientDialog
          key={dialog.id}
          isOpen
          close={() => closeDialog(dialog)}
          payload={dialog.payload}
        />
      );
      break;
    case 'PushMessage':
      component = (
        <PushMessage
          key={dialog.id}
          isOpen
          close={() => closeDialog(dialog)}
          payload={dialog.payload}
        />
      );
      break;
    case 'BulkPM':
      component = (
        <BulkPushMessage
          key={dialog.id}
          isOpen
          close={() => closeDialog(dialog)}
          payload={dialog.payload}
        />
      );
      break;
  }
  return component;
};

export const processParamGroups = (
  paramGroups: IDialogParamGroups,
  addDialog: (dialog: IDialog) => void,
  dialogs: JSX.Element[]
): void => {
  for (const groupKey in paramGroups) {
    const group = paramGroups[groupKey] as string[];
    if (!group.length) {
      continue;
    }
    if (groupKey === 'patient') {
      const patientIdChunk = group.find((chunk: string) =>
        chunk.includes('patientId')
      );
      if (!patientIdChunk) {
        continue;
      }
      const id = patientIdChunk.split('=')[1];
      const patientId = parseInt(id, 10);
      if (!patientId || isNaN(patientId)) {
        continue;
      }
      const dialogId = `viewPatient${patientId}`;
      const alreadyExists = dialogs.find(
        (dialogComponent) => dialogComponent.key === dialogId
      );
      if (alreadyExists) {
        continue;
      }
      const urlParam = group.join('&');
      const payload: any = { patientId };
      const patientTabIdChunk = group.find((chunk: string) =>
        chunk.includes('patientTab')
      );
      if (patientTabIdChunk) {
        const appKey = patientTabIdChunk.split('=')[1] as PatientTabIdType;
        if (appKey) {
          payload.tabId = appKey;
        }
      }
      addDialog({
        id: `viewPatient${patientId}`,
        name: 'ViewPatient',
        urlParam,
        payload
      });
    }
  }
};

export const removeSearchParamFromURL = (
  location: Location,
  dialogName: IDialogName
): string => {
  let search = location.search;
  if (!search || !search.length) {
    return `${location.pathname}${location.hash}`;
  }
  // Ex: ?patientId=4&patientTab=epxdiabetes
  search = search
    .replace('?', '')
    .split('&')
    .filter((piece) => {
      if (dialogName === 'ViewPatient') {
        if (piece.includes('patientId') || piece.includes('patientTab')) {
          return false;
        }
      }
      return true;
    })
    .join('&');
  if (!search.length) {
    return `${location.pathname}${location.hash}`;
  }
  return `${location.pathname}?${search}${location.hash}`;
};
